<template>
	<div class="container__registers">
		<ContentHeader>
			<SubHeader :title="title" />
		</ContentHeader>
		<ContentBody>
			<Card>
				<router-view />
			</Card>
		</ContentBody>
	</div>
</template>

<script>
import Card from '../../components/Card/Card'
import ContentBody from '../../components/ContentBody/ContentBody'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import SubHeader from '../../components/SubHeader/SubHeader'

export default {
	components: { Card, ContentBody, ContentHeader, SubHeader },
	data: () => {
		return {
			activeRoute: '',
		}
	},
	computed: {
		title() {
			return `${this.$t('help')} > ${this.label}`
		},
		label() {
			return this.labelAndLinkName.filter((f) => f.linkName === this.activeRoute)[0].label
		},
		labelAndLinkName() {
			return [
				{ label: this.$t('changelog'), linkName: 'changelog' },
				{ label: this.$t('tutorial'), linkName: 'treeviaacademy' },
			]
		},
	},
	watch: {
		$route(to) {
			this.activeRoute = to.name
		},
	},

	created() {
		this.activeRoute = this.$route.name
	},
}
</script>
